import { render } from "./ListPurchasesComponent.vue?vue&type=template&id=71947904"
import script from "./ListPurchasesComponent.vue?vue&type=script&lang=js"
export * from "./ListPurchasesComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen2/autoringen2.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/themes/default/js/components/purchases/ListPurchasesComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71947904"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71947904', __exports__)) {
    console.log('reload')
    api.reload('71947904', __exports__)
  }
  
  module.hot.accept("./ListPurchasesComponent.vue?vue&type=template&id=71947904", () => {
    console.log('re-render')
    api.rerender('71947904', render)
  })

}


export default __exports__